module.exports = __webpack_public_path__ + "img/arbre_a_perruque.7dfdf93c.jpg";